import { useToastMessagesStore } from "@/Stores/ToastMessagesStore";
import { useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import { can } from "@/Util/permissionChecks";
import { useCreateTeam } from "@/Service/Api/V1/ApiHooks/Teams/useCreateTeam";
import TeamForm, { TeamFormData } from "@/Components/Forms/TeamForm";
import { useNavigate } from "react-router-dom";
import {  url, sleep } from "@/Helpers/general";

const CreateTeamPage = () => {
    const navigate = useNavigate();
    const addToastMessage = useToastMessagesStore((state) => state.addToastMessage);

    const { mutateAsync: createTeam, isPending } = useCreateTeam();
    const queryClient = useQueryClient();

    const handleCreateTeam = async (data: TeamFormData) => {
        await createTeam({
            StoreTeamRequest: {
                ...data,
            }
        }, {
            onSuccess: async () => {
                await queryClient.invalidateQueries({
                    queryKey: QueryKeys.teams._def
                });
                addToastMessage({
                    severity: 'success',
                    summary: 'Team created',
                    detail: 'Team has been created successfully',
                });
                await sleep(2000);
                navigate(url('teams'));
            },
            onError: async (error) => {
                addToastMessage({
                    severity: 'error',
                    summary: 'Team creation failed',
                    detail: `Team creation failed ${error.message}`,
                });
            }
        });
    };

    return (
        <PageLayout>
            <TeamForm
                onSubmit={handleCreateTeam}
                isProcessing={isPending}
                onSubmitButtonLabel='Create team'
                onSubmitButtonDisabled={!can('create:team')}
            />
        </PageLayout>
    );
};

export default CreateTeamPage;